/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_UnpublishInputs */

const en_action_unpublish = /** @type {(inputs: Action_UnpublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unpublish`)
};

const es_action_unpublish = /** @type {(inputs: Action_UnpublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anular publicación`)
};

const fr_action_unpublish = /** @type {(inputs: Action_UnpublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dépublier`)
};

const de_action_unpublish = /** @type {(inputs: Action_UnpublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veröffentlichung aufheben`)
};

const ja_action_unpublish = /** @type {(inputs: Action_UnpublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`非公開にする`)
};

const zh_action_unpublish = /** @type {(inputs: Action_UnpublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取消发布`)
};

const ar_action_unpublish = /** @type {(inputs: Action_UnpublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إلغاء النشر`)
};

const id_action_unpublish = /** @type {(inputs: Action_UnpublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Batalkan Terbitan`)
};

const it_action_unpublish = /** @type {(inputs: Action_UnpublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annulla Pubblicazione`)
};

const ru_action_unpublish = /** @type {(inputs: Action_UnpublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Снять с публикации`)
};

const pt_action_unpublish = /** @type {(inputs: Action_UnpublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Despublicar`)
};

const ko_action_unpublish = /** @type {(inputs: Action_UnpublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`게시 취소`)
};

/**
* | output |
* | --- |
* | "Unpublish" |
*
* @param {Action_UnpublishInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const action_unpublish = /** @type {((inputs?: Action_UnpublishInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_UnpublishInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_action_unpublish(inputs)
	if (locale === "es") return es_action_unpublish(inputs)
	if (locale === "fr") return fr_action_unpublish(inputs)
	if (locale === "de") return de_action_unpublish(inputs)
	if (locale === "ja") return ja_action_unpublish(inputs)
	if (locale === "zh") return zh_action_unpublish(inputs)
	if (locale === "ar") return ar_action_unpublish(inputs)
	if (locale === "id") return id_action_unpublish(inputs)
	if (locale === "it") return it_action_unpublish(inputs)
	if (locale === "ru") return ru_action_unpublish(inputs)
	if (locale === "pt") return pt_action_unpublish(inputs)
	return ko_action_unpublish(inputs)
});